module.exports = __webpack_public_path__ + "img/99.253188b4.png";